import { cn } from '@rematter/ui-web';
import { Badge } from '@rematter/ui-web';
import { LucideMapPin } from 'lucide-react';

import { ServiceRecord } from '../../types';
import { getStatusColor } from '../../utils/serviceColors';

import { ServiceAssetLabel } from './ServiceAssetLabel';

interface ServiceContentProps {
  service: ServiceRecord;
  className?: string;
}

function formatDocumentNumber(num: number | string): string {
  return `#${String(num).padStart(6, '0')}`;
}

function getLocationTitle(service: ServiceRecord): string {
  const parts: string[] = [];
  if (service.serviceTypeName) {
    parts.push(service.serviceTypeName);
  }
  if (service.accountAddressName) {
    parts.push(`at ${service.accountAddressName}`);
  }
  return parts.join(' ') || '';
}

export const ServiceContent = ({
  service,
  className = '',
}: ServiceContentProps) => (
  <div
    className={cn(
      '@ServiceContent flex w-full flex-col justify-between p-1.5 select-none',
      className,
    )}
  >
    <div className="flex w-full items-center justify-between gap-1">
      <div className="shrink-0 text-xs text-foreground/60">
        {formatDocumentNumber(service.documentNumber)}
      </div>
      {service.accountName && (
        <div className="min-w-0 truncate text-xs text-foreground/50">
          {service.accountName}
        </div>
      )}
      <Badge
        color={getStatusColor(service.status)}
        size="xs"
        className="shrink-0"
      >
        {service.status}
      </Badge>
    </div>
    <div className="truncate text-sm font-semibold">
      {getLocationTitle(service)}
    </div>
    <div className="flex items-center justify-between gap-2">
      <div className="flex min-w-0 flex-1 items-center gap-1">
        <LucideMapPin size={12} className="shrink-0 text-foreground/40" />
        <div className="truncate text-xs text-foreground/60">
          {service.address?.streetAddress}
        </div>
      </div>
      <ServiceAssetLabel assetQuantities={service.assetQuantities} />
    </div>
  </div>
);
